export default "__VITE_PUBLIC_ASSET__00ec5f6f__"